import type { MarketVariants } from '@/lib/i18n'

export type Slide2FastModeCopy = {
  eyebrow: string
  /** Headline split around the italicised "fast" emphasis word. In Arabic the
   *  adjective follows the noun, so the emphasis lands at the end and
   *  `headlineAfter` is empty. */
  headlineBefore: string
  headlineEmphasis: string
  headlineAfter: string
  body: string
}

export const copy: MarketVariants<Slide2FastModeCopy> = {
  US: {
    eyebrow: 'The scammer’s goal',
    headlineBefore: 'Scammers are experts at putting you in ',
    headlineEmphasis: 'fast',
    headlineAfter: ' mode',
    body:
      'In fast mode, you stop asking questions. Who is this really? Why are they contacting me? Can I trust this? The pressure is designed to make sure you never get that far.',
  },
  ar: {
    eyebrow: 'هدف المحتال',
    headlineBefore: 'المحتالون خبراء في إدخالك إلى الوضع ',
    headlineEmphasis: 'السريع',
    headlineAfter: '',
    body:
      'في الوضع السريع، تتوقف عن طرح الأسئلة. من هذا الشخص حقاً؟ لماذا يتواصل معي؟ هل يمكنني الوثوق بهذا؟ الضغط مصمم لضمان ألا تصل إلى هذه الأسئلة أبداً.',
  },
}
